import React from 'react';
import { Snackbar, SnackbarContent } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle'; 

interface SavedSnackbarProps {
  open: boolean;
  message: string;
  onClose: (event: React.SyntheticEvent | Event, reason: "timeout" | "clickaway" | "escapeKeyDown") => void;
}

const SavedSnackbar: React.FC<SavedSnackbarProps> = ({ open, message, onClose }) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={3000}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <SnackbarContent
        style={{ 
          backgroundColor: '#4CAF50',
          color: '#fff',               
          display: 'flex',            
          alignItems: 'center',       
        }} 
        message={
          <span style={{ display: 'flex', alignItems: 'center' }}>
            <CheckCircleIcon style={{ marginRight: '8px' }} /> 
            {message}
          </span>
        }
       
      />
    </Snackbar>
  );
};

export default SavedSnackbar;
